import React, { useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
  Collapse,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

import { FiCheckCircle, FiExternalLink } from "react-icons/fi";
import { BsRocketTakeoff } from "react-icons/bs";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { postPaymentConfig, postTicketSales } from "../../../../utils/services/ticketeira";
import { fixedBody } from "../constants";
import { fi } from "date-fns/locale";

export const CreateTicketingApp = ({
  newRepository,
  setNewRepository,
  subDomain,
  setNewSubDomain,
  visible,
  setVisible,
  miceEventId,
  setMiceEventId,
  plusEventIdDev,
  setPlusEventIdDev,
  plusEventIdProd,
  setPlusEventIdProd,
  successDlg,
  setSuccessDlg,
  isLoading,
  setIsLoading,
  showDomains,
  setShowDomains,
  showInfo,
  setShowInfo,
  errors,
  setErrors,
  refetchPaymentConfig,
  idEvent,
  token,
}) => {
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrors({});
    setShowDomains(false);

    const body = {
      newRepository,
      subDomain,
      miceEventId: parseInt(miceEventId),
      plusEventIdDev,
      plusEventIdProd,
    };

    try {
      await postTicketSales(token, body);

      await postPaymentConfig(token, fixedBody(idEvent));

      setVisible(true);

      setTimeout(() => {
        setShowDomains(true);
        setSuccessDlg(true);
        refetchPaymentConfig();
      }, 180000);
    } catch (error) {
      console.log(error);
      setErrors({ general: "Erro ao criar ticketeira. Tente novamente." });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container fluid className="mt-4">
      {successDlg && (
        <SweetAlert
          success
          title="Ticketeira criada"
          onConfirm={() => setSuccessDlg(false)}
        >
          Em alguns instantes você poderá acessar o seu site!
        </SweetAlert>
      )}

      <Row>
        <Col xl="6">
          <Card className="card-shadow">
            <CardBody>
              <CardTitle tag="h4" className="mb-3">
                <BsRocketTakeoff size={20} className="me-2" />
                Criar novo site de venda de ingressos
              </CardTitle>

              <Form onSubmit={handleSubmit}>
                <FormGroup>
                  <Label for="miceEventId">🧠 Mice Evento ID</Label>
                  <Input
                    type="text"
                    id="miceEventId"
                    value={miceEventId}
                    disabled={visible}
                    onChange={(e) => setMiceEventId(e.target.value)}
                  />
                  {errors?.miceEventId && (
                    <div className="text-danger mt-1">{errors.miceEventId}</div>
                  )}
                </FormGroup>

                <FormGroup>
                  <Label for="plusEventIdDev">🧪 Plus Evento ID (Dev)</Label>
                  <Input
                    type="text"
                    id="plusEventIdDev"
                    value={plusEventIdDev}
                    disabled={visible}
                    onChange={(e) => setPlusEventIdDev(e.target.value)}
                  />
                  {errors?.plusEventIdDev && (
                    <div className="text-danger mt-1">
                      {errors.plusEventIdDev}
                    </div>
                  )}
                </FormGroup>

                <FormGroup>
                  <Label for="plusEventIdProd">🚀 Plus Evento ID (Prod)</Label>
                  <Input
                    type="text"
                    id="plusEventIdProd"
                    value={plusEventIdProd}
                    disabled={visible}
                    onChange={(e) => setPlusEventIdProd(e.target.value)}
                  />
                  {errors?.plusEventIdProd && (
                    <div className="text-danger mt-1">
                      {errors.plusEventIdProd}
                    </div>
                  )}
                </FormGroup>

                <FormGroup>
                  <Label for="subDomain">🌐 Subdomínio</Label>
                  <Input
                    type="text"
                    id="subDomain"
                    value={subDomain}
                    disabled={visible}
                    onChange={(e) => {
                      const value = e.target.value;
                      const regex = /^[a-zA-Z0-9-]*$/;
                      if (regex.test(value)) {
                        setNewSubDomain(value);
                        setNewRepository(value);
                      }
                    }}
                  />
                  {errors?.subDomain && (
                    <div className="text-danger mt-1">{errors.subDomain}</div>
                  )}
                </FormGroup>

                {!visible && (
                  <Button
                    color="primary"
                    type="submit"
                    block
                    className="btn-rounded"
                    disabled={isLoading}
                  >
                    {isLoading ? "Criando..." : "Criar Ticketeira"}
                  </Button>
                )}
              </Form>

              {visible && (
                <Alert color="info" className="mt-4">
                  <h5>
                    <FiCheckCircle className="me-2" />
                    Ticketeira em criação!
                  </h5>

                  <p>
                    Acompanhe o progresso no{" "}
                    <a
                      href={`https://github.com/inteegramice/${newRepository}-site`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      GitHub <FiExternalLink />
                    </a>
                  </p>

                  {!showDomains ? (
                    <>
                      <p className="mb-2">
                        ⏳ Estamos criando seu site, isso pode levar até{" "}
                        <strong>3 minutos</strong>...
                      </p>
                      <div className="d-flex align-items-center">
                        <div
                          className="spinner-border text-primary me-2"
                          role="status"
                        >
                          <span className="visually-hidden">Carregando...</span>
                        </div>
                        <span>Aguardando a finalização da criação...</span>
                      </div>
                    </>
                  ) : (
                    <>
                      <p className="mb-2">
                        ✅ Seu site está pronto! Acesse pelos domínios abaixo:
                      </p>
                      <ul className="mb-0">
                        <li>
                          <a
                            href={`https://${subDomain}.inteegratec.com.br`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {`${subDomain}.inteegratec.com.br`}
                          </a>
                        </li>
                        <li>
                          <a
                            href={`https://${subDomain}.sistemasinteegra.com.br`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {`${subDomain}.sistemasinteegra.com.br`}
                          </a>
                        </li>
                      </ul>
                    </>
                  )}
                </Alert>
              )}
            </CardBody>
          </Card>
        </Col>

        <Col xl="6">
          <Card className="card-shadow">
            <CardBody>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  cursor: "pointer",
                }}
                onClick={() => setShowInfo(!showInfo)}
              >
                <CardTitle tag="h5" className="mb-0">
                  <AiOutlineInfoCircle className="me-2" />
                  Informações sobre o processo
                </CardTitle>
                <span>{showInfo ? "▲" : "▼"}</span>
              </div>

              <Collapse isOpen={showInfo} className="mt-3">
                <Card color="light" className="mb-3 p-3">
                  <h6 className="text-primary">✨ Vantagens:</h6>
                  <ul>
                    <li>✓ Criação automática do site em minutos</li>
                    <li>✓ Integração completa com sistemas de pagamento</li>
                    <li>✓ Gestão centralizada de ingressos</li>
                    <li>✓ Deploy automático com cada atualização</li>
                  </ul>
                </Card>

                <Card color="light" className="p-3">
                  <h6 className="text-primary">🚀 Como Funciona:</h6>
                  <ol>
                    <li>Preencha os dados do seu evento</li>
                    <li>Aguarde cerca de 3 minutos para criação</li>
                    <li>Pronto! Acesse nos domínios informados</li>
                  </ol>
                </Card>
              </Collapse>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
